import {
  File,
  FileSchema,
  FileType,
  FileVisibility,
} from "@/gen_src/proto/chalk/server/v1/files_pb";
import {
  WorksheetNode,
  WorksheetNodeKind,
  WorksheetSpace,
  WorksheetSpaceVisibility,
} from "@/gen_src/proto/chalk/server/v1/worksheets_pb";
import type { QueryWorkspaceTabKind } from "@/components/query/sql/shared/sql-explorer.types";
import { createProto } from "@/utils/proto-utils";

export type WorksheetFile = File & {
  worksheetKind: QueryWorkspaceTabKind;
};

export const fileVisibilityToWorksheetSpaceVisibility = (
  fileVisibility: FileVisibility | undefined,
): WorksheetSpaceVisibility =>
  fileVisibility === FileVisibility.PRIVATE
    ? WorksheetSpaceVisibility.PRIVATE
    : WorksheetSpaceVisibility.SHARED;

export const worksheetSpaceVisibilityToFileVisibility = (
  visibility: WorksheetSpaceVisibility,
): FileVisibility =>
  visibility === WorksheetSpaceVisibility.PRIVATE ? FileVisibility.PRIVATE : FileVisibility.PUBLIC;

export const isSqlWorksheetNode = (node: WorksheetNode): boolean =>
  node.kind === WorksheetNodeKind.SQL_QUERY;

export const worksheetNodeKindToTabKind = (
  kind: WorksheetNodeKind,
): QueryWorkspaceTabKind | null => {
  switch (kind) {
    case WorksheetNodeKind.SQL_QUERY:
      return "sql";
    case WorksheetNodeKind.ONLINE_QUERY:
      return "online";
    case WorksheetNodeKind.OFFLINE_QUERY:
      return "offline";
    default:
      return null;
  }
};

export const isQueryWorksheetNode = (node: WorksheetNode): boolean =>
  worksheetNodeKindToTabKind(node.kind) != null;

export const worksheetNodeToFile = (
  node: WorksheetNode,
  space: WorksheetSpace,
  currentUserId?: string,
): WorksheetFile => ({
  ...createProto(FileSchema, {
    id: node.id,
    name: node.name,
    fileType: FileType.SQL_WORKSHEET,
    ownerId: space.ownerUserId ?? currentUserId ?? "",
    environmentId: node.environmentId,
    fileVisibility: worksheetSpaceVisibilityToFileVisibility(space.visibility),
    updatedAt: node.updatedAt,
  }),
  worksheetKind: worksheetNodeKindToTabKind(node.kind) ?? "sql",
});
